import styled from 'styled-components'

export const Title = styled.h2`
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 0 0 4px;

	svg {
		flex-shrink: 0;
	}
`
